<template>
  <div v-if="supplier.id" class="main-container">
    <div class="lg:flex">
      <div class="mx-auto pb-8">
        <div class="supplier-info lg:w-80">
          <img :src="supplier.companyOverview.logo">
          <div class="name-area md:w-3/4">
            <h4 class="text-xl font-medium leading-6 mb-1">
              {{ supplier.companyOverview.name }}
            </h4>
          </div>
          <div v-if="supplier.companyOverview.drsIframe" class="drs-area">
            <div
              class="px-18 md:w-content mx-auto"
              v-html="supplier.companyOverview.drsIframe"
            />
          </div>
          <div class="name-area">
            <p class="font-semibold">{{ supplier.companyOverview.name }}</p>
            <p>{{ supplier.companyOverview.description }}</p>
          </div>
          <div class="pt-5">
            <span class="font-semibold">Address:</span>
            {{ supplier.companyOverview.country }}
          </div>
        </div>
      </div>
      <InfoTabs :supplier="supplier" />
      <div class="fixed z-100 opacity-25 flex items-center justify-center inset-0 p-16 text-8xl pointer-events-none">
        Preview page
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import InfoTabs from '@/shared/components/supplier/supplierInfo/InfoTabs'

export default {
  name: 'SupplierInfo',
  components: {
    InfoTabs
  },
  data() {
    return {
      supplier: {},
      isChatOpen: false
    }
  },
  async created() {
    this.supplier = await this.fetchSupplierPreviewInfo(this.$route.params.id)
    document.title = this.supplier.companyOverview.name
  },
  methods: {
    ...mapActions ([
      'fetchSupplierPreviewInfo'
    ]),
    chatWithSupplier() {
      this.isChatOpen = true
    }
  }
}
</script>
<style lang="scss" scoped>
  .supplier-info {
    @apply p-5 border border-dark-b rounded-lg;
    @screen md { @apply flex flex-wrap justify-between px-8 }
    @screen lg { @apply block p-5 }
    img {
      @apply w-full;
      @screen md { @apply w-1/4 }
      @screen lg { @apply w-full }
    }
    .name-area {
      @apply py-5 border-b border-dark-b;
      @screen md { @apply border-transparent }
      @screen lg { @apply border-dark-b w-auto }
    }
    .drs-area {
      @apply py-8 border-b border-dark-b;
      @screen md { @apply border-transparent w-full }
      @screen lg { @apply border-dark-b w-auto }
    }
  }
</style>
